import React, { useEffect, useState } from "react";
import { Notification } from "./../common/Notification";
import { MonitorType } from "../../util/common";
import { manageMonitoring } from "../../store/service";
import { useTranslation } from "react-i18next";

interface IProps {
    accountOrCardNumber: string;
    monitorId: string | null;
    recordId: string;
    monitorType: number;
    closeDialog: any;
}

const DarkWebFinancialAccountConfirmDeleteDialog: React.FunctionComponent<IProps> = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const { t: tLang, i18n: i18nLang } = useTranslation();
    useEffect(() => {
        const cancelBtn: any = document.getElementById("btn-cancel-dark-web-delete");
        cancelBtn.addEventListener("click", () => props.closeDialog("cancel"));
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog("cancel");
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const deleteAccount = () => {
        let requestObj = {};
        if (props.monitorType == MonitorType.CreditCardMonitoring) {
            requestObj = {
                asset: {
                    creditCardInformation: {
                        "monitor-creditcard": {
                            "credit-card": props.accountOrCardNumber,
                            "record-id": props.recordId,
                            "monitor-id": props.monitorId,
                            "is-monitored": false,
                            action: "DELETE",
                        },
                    },
                },
            };
        } else if (props.monitorType == MonitorType.BankAccountMonitoring) {
            requestObj = {
                asset: {
                    bankAccountInformation: {
                        "monitor-bankaccount": {
                            "bank-account": props.accountOrCardNumber,
                            "record-id": props.recordId,
                            "monitor-id": props.monitorId,
                            "is-monitored": false,
                            action: "DELETE",
                        },
                    },
                },
            };
        } else if (props.monitorType == MonitorType.IBanAccountMonitoring) {
            requestObj = {
                asset: {
                    ibanAccountInformation: {
                        "monitor-ibanaccount": {
                            "bank-account": props.accountOrCardNumber,
                            "record-id": props.recordId,
                            "monitor-id": props.monitorId,
                            action: "DELETE",
                        },
                    },
                },
            };
        }
        setIsLoading(true);
        manageMonitoring(requestObj)
            .then((data) => {
                Notification({
                    type: "success",
                    title: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.deleteAccountPopup.toasterMessage.deleteSuccess.title") + monitoringTypeText(),
                    message: monitoringTypeText() + tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.deleteAccountPopup.toasterMessage.deleteSuccess.message"),
                    duration: 5,
                });
                props.closeDialog("close");
                setIsLoading(false);
            })
            .catch(function (error) {
                Notification({
                    type: "error",
                    title: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.deleteAccountPopup.toasterMessage.deleteError.title") + monitoringTypeText(),
                    message: monitoringTypeText() + tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.deleteAccountPopup.toasterMessage.deleteError.message"),
                    duration: 5,
                });
                setIsLoading(false);
            });
    };

    const monitoringTypeText = () => {
        let monitoringTypeText = tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.deleteAccountPopup.label.bankAccount") 
        if (props.monitorType == MonitorType.CreditCardMonitoring) {
            monitoringTypeText = tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.deleteAccountPopup.label.card") 
        
        }
        return monitoringTypeText;
    };

    return (
        <React.Fragment>
            <div className={`${isLoading && "loading"}`}>
                <div className="dialog-header">
                    <div className="dialog-icon status-default">
                        <em className="las la-trash-alt"></em>
                    </div>
                    <h1>{tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.deleteAccountPopup.title")}</h1>
                </div>
                <div className="dialog-body">
                    <p>{tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.deleteAccountPopup.deleteQuestionText")} {monitoringTypeText()}?</p>
                    <p>{props.accountOrCardNumber}</p>
                </div>
                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="button" id="btn-cancel-dark-web-delete" className="btn-default btn-link btn-no-padding btn-no-border">
                                <span className="btn-text">{tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.deleteAccountPopup.cancelButtonText")}</span>
                            </button>
                        </div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="button" className="btn-default btn-red" onClick={() => deleteAccount()}>
                                <span className="btn-icon">
                                    <em className="las la-trash-alt"></em>
                                </span>
                                <span className="btn-text">{tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.deleteAccountPopup.yesButtonText")}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default DarkWebFinancialAccountConfirmDeleteDialog;
